import { Link } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import CardDisplay from '../components/CardDisplay';
import TextArea from '../components/TextArea';
import WinnerList from '../components/WinnerList';
import ShowDate from '../components/ShowDate';

export default function Winners() {
  const { sharedMessage, setSharedMessage } = useAppContext();
  const sampleCards = [
    {
      imageUrl: "judero.jpg",
      title: "Judero",
      description: "Talha and Jack Co, J. King-Spooner, Talha Kaya",
      publisher: "Talha and Jack Co"
    },
    {
      imageUrl: "1000x.jpg",
      title: "Second Card",
      description: "sunset visitor 斜陽過客",
      publisher: "Fellow Traveller"
    },
    // Add more cards as needed
  ];
  
  return (
    <TextArea>
      <h1 className="text-4xl font-bold mb-6 text-[#fff444]" style={{ fontFamily: 'Belanosima', fontWeight: '400' }}>YAGA 2024 Winners</h1>
      <div>
        {/* <CardDisplay cards={sampleCards} columns={3} /> */}
        {/* <ShowDate /> */}
        <br></br>
        <p className="text-2xl text-gray-100 px-6" style={{ fontFamily: 'ABeeZee' }}>
        Here are your Winners of the 2024 Yet Another Game Awards! Thank you to all the nominees and the YAGA community.
        </p>
        <br></br>
        <WinnerList />
		<br></br>
		<p className="text-2xl text-gray-100 px-6" style={{ fontFamily: 'ABeeZee' }}>
		Congratulations to all of our winners! We hope you enjoyed the show. Thank you for joining us for the 2024 Yet Another Game Awards!
		</p>
      </div>
    </TextArea>
  );
}